export default __webpack_public_path__ + "static/media/vlcc_radiance_pro_spf_30_pa_sunscreen_gel_50_gm_0_1.799c6f6f.dib";